<template>
  <v-card
    :style="
      $vuetify.theme.dark
        ? 'margin: 8px 8px auto 8px;'
        : 'margin: 8px 16px auto 16px'
    "
    class="nav-recap-banner"
    flat
    @click="openRecapModal"
  >
    <div
      class="nav-recap-banner-image"
      :class="{ 'mobile-breakpoint': isMobileBreakpoint }"
    >
      <span v-if="isMobileBreakpoint" class="nav-title-banner">
        {{ $t('message.banners.recap.navDrawerTitleMobile') }}
      </span>
      <img :src="recapSvg" class="nav-recap-banner-svg" />
    </div>
    <div
      class="d-flex"
      style="justify-content: center !important; align-items: center !important"
    >
      <simple-svg
        :src="require('@/assets/pandaIcons/go.svg')"
        width="24px"
        height="24px"
        fill-class-name="fill-color"
        fill="white"
      />
    </div>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'NavDrawerRecapBanner',
  data() {
    return {
      recapSvg: null,
    }
  },
  created() {
    this.recapSvg = require(`@/assets/recap/navDrawerRecapBanner/navRecapBanner2024-${this.locale}.svg`)
  },
  watch: {
    '$i18next.resolvedLanguage': {
      handler(val) {
        this.recapSvg = require(`@/assets/recap/navDrawerRecapBanner/navRecapBanner2024-${val}.svg`)
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    locale() {
      return this.$i18next.resolvedLanguage
    },
  },
  methods: {
    openRecapModal() {
      this.$emit('openRecapModal')
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-recap-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 4px 16px 8px;
  border-radius: 8px;
  background-color: #3f55ee !important;
}

.nav-recap-banner-image {
  flex: 1;
  display: flex;
  justify-content: center;
  margin-left: -20px;
  scale: 1.35;

  &.mobile-breakpoint {
    margin-left: 0 !important;
    scale: 1 !important;
    flex-direction: column !important;
  }
}

.nav-recap-banner-svg {
  height: 36px;
  width: 119px;
}

.nav-title-banner {
  color: var(--neutral-100-white, #fff);
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
</style>
